// khách hàng
export const GET_LIST_CUSTOMER_INVOICE = "GET_LIST_CUSTOMER_INVOICE";
export const GET_LIST_CUSTOMER_INVOICE_SUCCESS =
  "GET_LIST_CUSTOMER_INVOICE_SUCCESS";
export const GET_LIST_CUSTOMER_INVOICE_FAIL = "GET_LIST_CUSTOMER_INVOICE_FAIL";
export const RESET_LIST_CUSTOMER_INVOICE = "RESET_LIST_CUSTOMER_INVOICE";

// Chi tiết khách hàng
export const GET_DETAIL_CUSTOMER_INVOICE = "GET_DETAIL_CUSTOMER_INVOICE";
export const GET_DETAIL_CUSTOMER_INVOICE_SUCCESS =
  "GET_DETAIL_CUSTOMER_INVOICE_SUCCESS";
export const GET_DETAIL_CUSTOMER_INVOICE_FAIL =
  "GET_DETAIL_CUSTOMER_INVOICE_FAIL";
export const RESET_DETAIL_CUSTOMER_INVOICE = "RESET_DETAIL_CUSTOMER_INVOICE";

// Tạo khách hàng
export const CREATE_CUSTOMER_INVOICE = "CREATE_CUSTOMER_INVOICE";
export const CREATE_CUSTOMER_INVOICE_SUCCESS =
  "CREATE_CUSTOMER_INVOICE_SUCCESS";
export const CREATE_CUSTOMER_INVOICE_FAIL = "CREATE_CUSTOMER_INVOICE_FAIL";
export const RESET_CREATE_CUSTOMER_INVOICE = "RESET_CREATE_CUSTOMER_INVOICE";

// EDIT khách hàng
export const EDIT_CUSTOMER_INVOICE = "EDIT_CUSTOMER_INVOICE";
export const EDIT_CUSTOMER_INVOICE_SUCCESS = "EDIT_CUSTOMER_INVOICE_SUCCESS";
export const EDIT_CUSTOMER_INVOICE_FAIL = "EDIT_CUSTOMER_INVOICE_FAIL";
export const RESET_EDIT_CUSTOMER_INVOICE = "RESET_EDIT_CUSTOMER_INVOICE";

// delete khách hàng
export const DELETE_CUSTOMER_INVOICE = "DELETE_CUSTOMER_INVOICE";
export const DELETE_CUSTOMER_INVOICE_SUCCESS =
  "DELETE_CUSTOMER_INVOICE_SUCCESS";
export const DELETE_CUSTOMER_INVOICE_FAIL = "DELETE_CUSTOMER_INVOICE_FAIL";
export const RESET_DELETE_CUSTOMER_INVOICE = "RESET_DELETE_CUSTOMER_INVOICE";

// GET_ALL_CUSTOMER_INVOICE
export const GET_ALL_CUSTOMER_INVOICE = "GET_ALL_CUSTOMER_INVOICE";
export const GET_ALL_CUSTOMER_INVOICE_SUCCESS =
  "GET_ALL_CUSTOMER_INVOICE_SUCCESS";
export const GET_ALL_CUSTOMER_INVOICE_FAIL = "GET_ALL_CUSTOMER_INVOICE_FAIL";
export const RESET_GET_ALL_CUSTOMER_INVOICE = "RESET_GET_ALL_CUSTOMER_INVOICE";

// GET_ALL_ACCOUNT_BANK
export const GET_ALL_ACCOUNT_BANK = "GET_ALL_ACCOUNT_BANK";
export const GET_ALL_ACCOUNT_BANK_SUCCESS = "GET_ALL_ACCOUNT_BANK_SUCCESS";
export const GET_ALL_ACCOUNT_BANK_FAIL = "GET_ALL_ACCOUNT_BANK_FAIL";
export const RESET_GET_ALL_ACCOUNT_BANK = "RESET_GET_ALL_ACCOUNT_BANK";

//
export const SET_COLUMN_VISIBLE_CUSTOMER_INVOICE =
  "SET_COLUMN_VISIBLE_CUSTOMER_INVOICE";

// Tạo tài khoản ngân hàng
export const CREATE_ACCOUNT_BANK = "CREATE_ACCOUNT_BANK";
export const CREATE_ACCOUNT_BANK_SUCCESS = "CREATE_ACCOUNT_BANK_SUCCESS";
export const CREATE_ACCOUNT_BANK_FAIL = "CREATE_ACCOUNT_BANK_FAIL";
export const RESET_CREATE_ACCOUNT_BANK = "RESET_CREATE_ACCOUNT_BANK";
